import { Predicates } from "../../../libraries/predicates/predicates";
import { MasterArtworkNumberState } from "../../../states/meta-artwork/artwork-number/data.type";

export const formatArtworkNumberOptions = (item: MasterArtworkNumberState| null) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
      value: item,
      label: `${item.code}`,
    }
    : null;
}

export const formatArtworkNumberOptionsPartial = (item: Partial<MasterArtworkNumberState> | null) => {
  if (!item || !item.code) return null;

  return {
    value: item,
    label: `${item.code}`,
  };
};

export const getArtworkNumber = (artworkNumbers: MasterArtworkNumberState[]) =>
  artworkNumbers.map(formatArtworkNumberOptions).filter(Predicates.isNotNullAndNotUndefined)
